export const BACKEND_URL = window.location.origin.includes('localhost')
  ? 'http://localhost:5000'
  : '';

export const TASK_STATUS = {
  RUNNING: 'running',
  STOPPING: 'stopping',
  STOPPED: 'stopped',
  ERROR: 'error',
  DONE: 'done',
};

// Wrap fetch so every API call sends the session cookie and a global 401
// bounces the user back to the login screen.
export async function apiFetch(path, opts = {}) {
  const url = path.startsWith('http') ? path : `${BACKEND_URL}${path}`;
  const res = await fetch(url, { ...opts, credentials: 'include' });
  if (res.status === 401) {
    window.dispatchEvent(new CustomEvent('netgen-unauthorized'));
  }
  return res;
}
